import { render, staticRenderFns } from "./freeDialog.vue?vue&type=template&id=51cf76f4&scoped=true&"
import script from "./freeDialog.vue?vue&type=script&lang=js&"
export * from "./freeDialog.vue?vue&type=script&lang=js&"
import style0 from "./freeDialog.vue?vue&type=style&index=0&id=51cf76f4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cf76f4",
  null
  
)

export default component.exports